import { Injectable } from '@angular/core'
import { createEffect, Actions, ofType } from '@ngrx/effects'
import { GoogleAnalyticsService, GaActionEnum } from 'ngx-google-analytics'
import { tap } from 'rxjs'
import * as GoogleAnalyticsActions from './google-analytics.actions'

@Injectable()
export class GoogleAnalyticsEffects {
  trackViewItemListEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GoogleAnalyticsActions.trackViewItemListEvent),
        tap(() => this.$gaService.gtag('event', GaActionEnum.VIEW_ITEM_LIST)),
      ),
    { dispatch: false },
  )

  trackViewItemEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GoogleAnalyticsActions.trackViewItemEvent),
        tap((action) =>
          this.$gaService.gtag('event', GaActionEnum.VIEW_ITEM, {
            items: [action.item],
          }),
        ),
      ),
    { dispatch: false },
  )

  trackAddToCartEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GoogleAnalyticsActions.trackAddToCartEvent),
        tap((action) =>
          this.$gaService.gtag('event', GaActionEnum.ADD_TO_CART, {
            items: [action.item],
          }),
        ),
      ),
    { dispatch: false },
  )

  trackBeginCheckoutEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GoogleAnalyticsActions.trackBeginCheckoutEvent),
        tap((action) =>
          this.$gaService.gtag('event', GaActionEnum.BEGIN_CHECKOUT, {
            items: [action.item],
          }),
        ),
      ),
    { dispatch: false },
  )

  trackRemoveFromCartEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GoogleAnalyticsActions.trackRemoveFromCartEvent),
        tap((action) =>
          this.$gaService.gtag('event', GaActionEnum.REMOVE_FROM_CART, {
            items: [action.item],
          }),
        ),
      ),
    { dispatch: false },
  )

  trackPurchaseEvent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GoogleAnalyticsActions.trackPurchaseEvent),
        tap((action) =>
          this.$gaService.gtag('event', GaActionEnum.PURCHASE, {
            items: [action.item],
            currency: action.currency,
            value: action.value,
            transaction_id: action.transaction_id,
            tax: action.tax,
          }),
        ),
      ),
    { dispatch: false },
  )

  constructor(private actions$: Actions, private $gaService: GoogleAnalyticsService) {}
}
